<ul>
	<li [hasPermission]="'upload & encode'" [ngClass]="{'active': activeLink === 'upload-transcode'}"><a
			[routerLink]="['/library/upload-transcode/upload']"><i class="fa fa-upload"></i>
			{{ 'UPLOAD_TRANSCODE' | translate }}</a></li>

	<li [hasPermission]="'mediaclips'" [ngClass]="{'active': activeLink === 'mediaclip'}"><a
			[routerLink]="['/library/mediaclips']"><i class="fa fa-film"></i>
			{{ 'MEDIACLIPS' | translate }}</a></li>

	<li [hasPermission]="'projects'" [ngClass]="{'active': activeLink === 'project'}"><a
			[routerLink]="['/library/projects']"><i class="fa fa-paper-plane"></i>
			{{ 'PROJECTS' | translate }}</a></li>

	<li [hasPermission]="'interactivity'" [ngClass]="{'active': activeLink === 'template'}"><a
			[routerLink]="['/library/templates']"><i class="fa fa-cube"></i>
			{{ 'TEMPLATES' | translate }}</a></li>

	<li [hasPermission]="'placements'" [ngClass]="{'active': activeLink === 'placement'}"><a
			[routerLink]="['/library/placements']"><i class="fa fa-square-o"></i>
			{{ 'PLACEMENTS' | translate }}</a></li>

	<li [hasPermission]="'playouts'" [ngClass]="{'active': activeLink === 'playout'}"><a
			[routerLink]="['/library/playouts']"><i class="fa fa-sliders"></i>
			{{ 'PLAYOUTS' | translate }}</a></li>

	<li [hasPermission]="'playlists'" [ngClass]="{'active': activeLink === 'playlist'}"><a
			[routerLink]="['/library/playlists']"><i class="fa fa-list-ol"></i>
			{{ 'PLAYLISTS' | translate }}</a></li>

	<li [hasPublicationField]="'channels'" [ngClass]="{'active': activeLink === 'channel'}"><a
			[routerLink]="['/library/channels']"><i class="fa fa-th"></i>
			{{ 'CHANNELS' | translate }}</a></li>

	<li [hasPublicationFieldOrPermission]="'datafeeds'" [ngClass]="{'active': activeLink === 'datafeed'}"><a
			[routerLink]="['/library/datafeeds']"><i class="fa fa-table"></i>
			{{ 'DATAFEEDS' | translate }}</a></li>

	<li [hasPermission]="'social'" routerLinkActive="active"><a [routerLink]="['/library/social']"><i
				class="fa fa-share-alt"></i>
			{{ 'SOCIAL' | translate }}</a></li>

	<li [hasPublicationField]="'lineups'" [ngClass]="{'active': activeLink === 'lineup'}"><a
			[routerLink]="['/library/lineups']"><i class="fa fa-tv"></i>
			{{ 'LINEUPS' | translate }}</a></li>

	<li [hasPermission]="'delete'" class="trash" routerLinkActive="active"><a [routerLink]="['/library/trash']"><i
				class="fa fa-trash"></i>
			{{ 'TRASH' | translate}}</a></li>
</ul>
